export const TX_WAIT_BLOCKS = 1;

export const TX_GAS_LIMIT = 700000;
